<app-table
    [data]="channels"
    [columns]="columns"
    [pageSize]="7"
    [allowedPageSizes]="[7]"
    [showPageSizeSelector]="false"
    [showGrouping]="false"
></app-table>
